import React, { useEffect, useState } from 'react';
import SupplierField from './SupplierField';


const AddSupplier = () => {
     return (
        <div className='tenant-page'>
            <h1 className='tenant-page__heading tenant-page__heading--single'>Add A Supplier</h1>
            <div className='transaction-panel mt-4'><SupplierField></SupplierField></div>
        </div>
    );
};

export default AddSupplier;
